import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicCreditHistoryService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public perform(id): Observable<any> {
    return this.publicHttp
      .get("/api/public/credit_history/" + id + "/consultar")
      .pipe(tap((_) => console.log("CreditHistoryService.perform: Ok.")));
  }

  public create(consulta: any): Observable<any> {
    return this.publicHttp
      .post("/api/public/credit_history", { consulta_buro: consulta })
      .pipe(tap((_) => console.log("CreditHistoryService.create: Ok.")));
  }

  public assign(person_id, consulta_buro_id): Observable<Response> {
    return this.publicHttp
      .put("/api/public/persons/" + person_id + "/credit_history/" + consulta_buro_id + "/assign", null)
      .pipe(tap((_) => console.log("CreditHistoryService.assign: Ok.")));
  }

  public presence(country_state: string): Observable<boolean> {
    const options = { params: { estado: country_state } };
    return this.publicHttp
      .get("/api/public/consultas_buros/presencia", options)
      .pipe(tap((_) => console.log("CreditHistoryService.presence: Ok.")));
  }

  public updatePresence(consulta_id: string | number, country_state: string): Observable<any> {
    let options = { estado_residencia: country_state };
    return this.publicHttp
      .put("/api/public/credit_history/" + consulta_id + "/update_residence", options)
      .pipe(tap((_) => console.log("CreditHistoryService.updatePresence: Ok.")));
  }

  public bestOfPersonId(person_id: string | number): Observable<any> {
    return this.publicHttp
      .get("/api/public/persons/" + person_id + "/credit_history/best")
      .pipe(tap((_) => console.log("CreditHistoryService.bestOfPersonId: Ok.")));
  }

  public updateAndDownloadAgain(consulta_buro: any): Observable<any> {
    return this.publicHttp
      .put("/api/public/credit_history/" + consulta_buro.id + "/update_and_download_again", {
        consulta_buro,
      })
      .pipe(tap((_) => console.log("CreditHistoryService.updateAndDownloadAgain: Ok.")));
  }

  public createJob(id: string): Observable<any> {
    return this.publicHttp
      .get("/api/public/persons/" + id + "/credit_history/create_bc_job")
      .pipe(tap((_) => console.log("CreditHistoryService.createJob: Ok.")));
  }
}
